import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import PainterBigBay from '../pages/painter-profile/components/PainterBigBay';
import PainterBloubergstrand from '../pages/painter-profile/components/PainterBloubergstrand';
import PainterBothasig from '../pages/painter-profile/components/PainterBothasig';
import PainterCampsBay from '../pages/painter-profile/components/PainterCampsBay';
import PainterCenturyCity from '../pages/painter-profile/components/PainterCenturyCity';
import PainterClaremont from '../pages/painter-profile/components/PainterClaremont';
import PainterClifton from '../pages/painter-profile/components/PainterClifton';
import PainterEdgemead from '../pages/painter-profile/components/PainterEdgemead';
import PainterGeorge from '../pages/painter-profile/components/PainterGeorge';
import PainterGoodwood from '../pages/painter-profile/components/PainterGoodwood';
import PainterHermanus from '../pages/painter-profile/components/PainterHermanus';
import PainterMalmesbury from '../pages/painter-profile/components/PainterMalmesbury';
import PainterMelkbosstrand from '../pages/painter-profile/components/PainterMelkbosstrand';
import PainterMilnerton from '../pages/painter-profile/components/PainterMilnerton';
import PainterNewlands from '../pages/painter-profile/components/PainterNewlands';
import PainterPaarl from '../pages/painter-profile/components/PainterPaarl';
import PainterParklands from '../pages/painter-profile/components/PainterParklands';
import PainterRondebosch from '../pages/painter-profile/components/PainterRondebosch';
import PainterTableView from '../pages/painter-profile/components/PainterTableView';
import PainterBellville from '../pages/painter-profile/components/PainterBellville';
import PainterParow from '../pages/painter-profile/components/PainterParow';
import PainterBrackenfell from '../pages/painter-profile/components/PainterBrackenfell';
import PainterSunningdale from '../pages/painter-profile/components/PainterSunningdale';
import PainterSeaPoint from '../pages/painter-profile/components/PainterSeaPoint';
import PainterGreenPoint from '../pages/painter-profile/components/PainterGreenPoint';
import PainterPlattekloof from '../pages/painter-profile/components/PainterPlattekloof';
import PainterWoodstock from '../pages/painter-profile/components/PainterWoodstock';
import PainterTamboerskloof from '../pages/painter-profile/components/PainterTamboerskloof';
import PainterNoordhoek from '../pages/painter-profile/components/PainterNoordhoek';
import PainterFishHoek from '../pages/painter-profile/components/PainterFishHoek';
import PainterSimonsTown from '../pages/painter-profile/components/PainterSimonsTown';
import PainterWestBeach from '../pages/painter-profile/components/PainterWestBeach';
import PainterMuizenberg from '../pages/painter-profile/components/PainterMuizenberg';
import PainterDewaterkant from '../pages/painter-profile/components/PainterDewaterkant';
import PainterStellenberg from '../pages/painter-profile/components/PainterStellenberg';
import PainterSunsetbeach from '../pages/painter-profile/components/PainterSunsetbeach';
import PainterFlamingovlei from '../pages/painter-profile/components/PainterFlamingovlei';
import PainterSandown from '../pages/painter-profile/components/PainterSandown';
import PainterKalkbay from '../pages/painter-profile/components/PainterKalkbay';
import PainterRoyalascot from '../pages/painter-profile/components/PainterRoyalascot';
import PainterTygerberg from '../pages/painter-profile/components/PainterTygerberg';
import PainterKommetjie from '../pages/painter-profile/components/PainterKommetjie';

const Home = lazy(() => import('../pages/home/page'));
const FindPainters = lazy(() => import('../pages/find-painters/page'));
const PainterProfile = lazy(() => import('../pages/painter-profile/page'));
const Quote = lazy(() => import('../pages/quote/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/find-painters',
    element: <FindPainters />,
  },
  {
    path: '/painter/painters-big-bay',
    element: <PainterBigBay />,
  },
  {
    path: '/painter/painters-bloubergstrand',
    element: <PainterBloubergstrand />,
  },
  {
    path: '/painter/painters-bothasig',
    element: <PainterBothasig />,
  },
  {
    path: '/painter/painters-camps-bay',
    element: <PainterCampsBay />,
  },
  {
    path: '/painter/painters-century-city',
    element: <PainterCenturyCity />,
  },
  {
    path: '/painter/painters-claremont',
    element: <PainterClaremont />,
  },
  {
    path: '/painter/painters-clifton',
    element: <PainterClifton />,
  },
  {
    path: '/painter/painters-edgemead',
    element: <PainterEdgemead />,
  },
  {
    path: '/painter/painters-george',
    element: <PainterGeorge />,
  },
  {
    path: '/painter/painters-goodwood',
    element: <PainterGoodwood />,
  },
  {
    path: '/painter/painters-hermanus',
    element: <PainterHermanus />,
  },
  {
    path: '/painter/painters-malmesbury',
    element: <PainterMalmesbury />,
  },
  {
    path: '/painter/painters-melkbosstrand',
    element: <PainterMelkbosstrand />,
  },
  {
    path: '/painter/painters-milnerton',
    element: <PainterMilnerton />,
  },
  {
    path: '/painter/painters-newlands',
    element: <PainterNewlands />,
  },
  {
    path: '/painter/painters-paarl',
    element: <PainterPaarl />,
  },
  {
    path: '/painter/painters-parklands',
    element: <PainterParklands />,
  },
  {
    path: '/painter/painters-rondebosch',
    element: <PainterRondebosch />,
  },
  {
    path: '/painter/painters-table-view',
    element: <PainterTableView />,
  },
  {
    path: '/painter/bellville-painters',
    element: <PainterBellville />,
  },
  {
    path: '/painter/painters-parow',
    element: <PainterParow />,
  },
  {
    path: '/painter/painters-brackenfell',
    element: <PainterBrackenfell />,
  },
  {
    path: '/painter/painters-sunningdale',
    element: <PainterSunningdale />,
  },
  {
    path: '/painter/painters-sea-point',
    element: <PainterSeaPoint />,
  },
  {
    path: '/painter/painters-green-point',
    element: <PainterGreenPoint />,
  },
  {
    path: '/painter/painters-plattekloof',
    element: <PainterPlattekloof />,
  },
  {
    path: '/painter/painters-woodstock',
    element: <PainterWoodstock />,
  },
  {
    path: '/painter/painters-tamboerskloof',
    element: <PainterTamboerskloof />,
  },
  {
    path: '/painter/painters-noordhoek',
    element: <PainterNoordhoek />,
  },
  {
    path: '/painter/painters-fish-hoek',
    element: <PainterFishHoek />,
  },
  {
    path: '/painter/painters-simons-town',
    element: <PainterSimonsTown />,
  },
  {
    path: '/painter/painters-west-beach',
    element: <PainterWestBeach />,
  },
  {
    path: '/painter/painters-muizenberg',
    element: <PainterMuizenberg />,
  },
  {
    path: '/painter/painters-dewaterkant',
    element: <PainterDewaterkant />,
  },
  {
    path: '/painter/painters-stellenberg',
    element: <PainterStellenberg />,
  },
  {
    path: '/painter/painters-sunset-beach',
    element: <PainterSunsetbeach />,
  },
  {
    path: '/painter/painters-flamingo-vlei',
    element: <PainterFlamingovlei />,
  },
  {
    path: '/painter/painters-sandown',
    element: <PainterSandown />,
  },
  {
    path: '/painter/painters-kalk-bay',
    element: <PainterKalkbay />,
  },
  {
    path: '/painter/painters-royal-ascot',
    element: <PainterRoyalascot />,
  },
  {
    path: '/painter/painters-tygerberg',
    element: <PainterTygerberg />,
  },
  {
    path: '/painter/painters-kommetjie',
    element: <PainterKommetjie />,
  },
  {
    path: '/painter/:id',
    element: <PainterProfile />,
  },
  {
    path: '/quote',
    element: <Quote />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
